// eslint-disable-next-line import/no-extraneous-dependencies
import React, { useState, useEffect } from 'react'
// import type { PlayerRow } from './App.tsx'
import { PlayerHeaderProps } from './utils/types.ts'

import {
    SAVANT_GREEN,
    NAME_TEXT_TOP_OFFSET,
    NAME_TEXT_OFFSET,
    YEAR_TEXT_OFFSET,
    TEAM_LOGO_OFFSET,
    TEAM_LOGO_SIZE,
} from './utils/constants.ts'
import { useDimensions } from './utils/responsive-dimensions.tsx'

function PlayerHeader(props: PlayerHeaderProps) {
    const { IMG_WIDTH, IMG_TOP_BUFFER } = useDimensions()

    const { data, maxSliderWidth, numPlayers, showTeams } = props
    const { id, player_name, year, teams } = data
    // const imgUrl = `https://midfield.mlbstatic.com/v1/people/${id}/mlb/120?circle=true`
    // const proxyUrl = `/comparison-tool/services/api/${encodeURIComponent(
    //     imgUrl
    // )}`

    const teamsToDisplay = (teams ?? []) as number[]
    const teamLogoGap = 2
    const teamLogoStep = TEAM_LOGO_SIZE + teamLogoGap
    const totalTeamsWidth =
        teamsToDisplay.length > 0
            ? teamsToDisplay.length * TEAM_LOGO_SIZE +
              (teamsToDisplay.length - 1) * teamLogoGap
            : 0

    const nameTokens = (player_name as string).split(', ')
    const firstName = nameTokens[1]
    const lastName = nameTokens[0]

    const imgX = (maxSliderWidth - IMG_WIDTH) / 2

    const [headshotBase64, setHeadshotBase64] = useState<string | null>(null)
    const [teamLogosBase64, setTeamLogosBase64] = useState<
        Record<number, string>
    >({})

    useEffect(() => {
        const mlbUrl = `https://midfield.mlbstatic.com/v1/people/${id}/mlb/120?circle=true`
        const proxyUrl = `/comparison-tool/services/api/${encodeURIComponent(
            mlbUrl
        )}`

        fetch(proxyUrl)
            .then((response) => response.blob()) // Get the raw binary blob
            .then((blob) => {
                const reader = new FileReader()
                reader.onloadend = () => {
                    setHeadshotBase64(reader.result as string)
                }
                reader.readAsDataURL(blob)
            })
            .catch((err) => console.error('Failed to load headshot', err))

        // --- FETCH TEAM LOGOS (Using Promise.all for speed) ---
        const fetchTeamLogos = async () => {
            const logoMap: Record<number, string> = {}

            await Promise.all(
                teamsToDisplay.map(async (teamId) => {
                    const teamUrl = `https://www.mlbstatic.com/team-logos/${teamId}.svg`
                    const teamProxy = `/comparison-tool/services/api/${encodeURIComponent(
                        teamUrl
                    )}`

                    try {
                        const res = await fetch(teamProxy)
                        const blob = await res.blob()

                        const base64 = await new Promise<string>((resolve) => {
                            const reader = new FileReader()
                            reader.onloadend = () =>
                                resolve(reader.result as string)
                            reader.readAsDataURL(blob)
                        })

                        logoMap[teamId] = base64
                    } catch (err) {
                        console.error(`Failed to load team ${teamId}`, err)
                    }
                })
            )
            setTeamLogosBase64(logoMap)
        }

        if (teamsToDisplay.length > 0) {
            fetchTeamLogos()
        }
    }, [id, teamsToDisplay])

    return (
        <>
            <circle
                cx={maxSliderWidth / 2}
                cy={IMG_TOP_BUFFER + IMG_WIDTH / 2}
                r={IMG_WIDTH / 2}
                strokeWidth={4}
                stroke={SAVANT_GREEN}
                fill={SAVANT_GREEN}
                // onMouseHover={() => setIsHovered(true)}
            />
            <image
                x={imgX}
                y={IMG_TOP_BUFFER}
                href={headshotBase64!}
                width={IMG_WIDTH}
                height={IMG_WIDTH}
            />
            <text
                x={maxSliderWidth / 2}
                y={IMG_TOP_BUFFER + IMG_WIDTH + NAME_TEXT_TOP_OFFSET}
                className="player-name"
                style={{
                    fontFamily: 'Roboto Condensed',
                    fontSize:
                        firstName.length > 13 && numPlayers > 6
                            ? '12px'
                            : '14px',
                }}
                textLength={
                    firstName.length > 13 && numPlayers > 6
                        ? IMG_WIDTH
                        : undefined
                }
            >
                {firstName}
            </text>
            <text
                x={maxSliderWidth / 2}
                y={
                    IMG_TOP_BUFFER +
                    IMG_WIDTH +
                    NAME_TEXT_TOP_OFFSET +
                    NAME_TEXT_OFFSET
                }
                className="player-name"
                style={{
                    fontFamily: 'Roboto Condensed',
                    fontSize:
                        lastName.length > 13 && numPlayers > 6
                            ? '12px'
                            : '14px',
                }}
                textLength={
                    lastName.length > 13 && numPlayers > 6
                        ? IMG_WIDTH
                        : undefined
                }
            >
                {lastName}
            </text>
            <text
                x={maxSliderWidth / 2}
                y={
                    IMG_TOP_BUFFER +
                    IMG_WIDTH +
                    NAME_TEXT_TOP_OFFSET +
                    NAME_TEXT_OFFSET +
                    YEAR_TEXT_OFFSET
                }
                className="player-year"
                style={{ fontFamily: 'Roboto Condensed' }}
            >
                {/* {`${year}${ohtaniText}`} */}
                {year}
            </text>
            <g
                transform={`translate(${
                    maxSliderWidth / 2 - totalTeamsWidth / 2
                }, ${
                    IMG_TOP_BUFFER +
                    IMG_WIDTH +
                    NAME_TEXT_TOP_OFFSET +
                    NAME_TEXT_OFFSET +
                    YEAR_TEXT_OFFSET +
                    TEAM_LOGO_OFFSET
                })`}
            >
                {showTeams &&
                    teamsToDisplay.map((team, idx) => {
                        const logoData = teamLogosBase64[team]
                        return logoData ? (
                            <image
                                key={team}
                                x={idx * teamLogoStep}
                                y={0}
                                href={logoData}
                                width={TEAM_LOGO_SIZE}
                                height={TEAM_LOGO_SIZE}
                            />
                        ) : null
                    })}
            </g>
        </>
    )
}

export default PlayerHeader
